/**
 * Copyright (c) 2026 Accunai India Services Pvt. Ltd. All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This file is part of proprietary software owned by Accunai India Services Pvt. Ltd.
 * Unauthorized copying, distribution, modification, or use of this file,
 * in whole or in part, via any medium, is strictly prohibited without
 * prior written permission from Accunai India Services Pvt. Ltd.
 *
 * Generated with GitHub Copilot Business/Enterprise.
 * Reviewed and approved by: AI-assisted / 2026-07-02
 */

const TOKEN_COOKIE_KEY = "token";
const REFRESH_TOKEN_COOKIE_KEY = "refresh_token";

export const setAuthTokenCookie = (token: string, days = 7): void => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  const secure = window.location.protocol === "https:" ? ";Secure" : "";
  document.cookie = `${TOKEN_COOKIE_KEY}=${token};${expires};path=/;SameSite=Lax${secure}`;
};

export const getAuthTokenCookie = (): string | null => {
  const name = `${TOKEN_COOKIE_KEY}=`;
  const allCookies = document.cookie.split(";");

  for (let index = 0; index < allCookies.length; index += 1) {
    let cookie = allCookies[index];
    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1);
    }

    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length);
    }
  }

  return null;
};

export const setRefreshTokenCookie = (token: string, days = 14): void => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  const secure = window.location.protocol === "https:" ? ";Secure" : "";
  document.cookie = `${REFRESH_TOKEN_COOKIE_KEY}=${token};${expires};path=/;SameSite=Lax${secure}`;
};

export const getRefreshTokenCookie = (): string | null => {
  const name = `${REFRESH_TOKEN_COOKIE_KEY}=`;
  const allCookies = document.cookie.split(";");

  for (let index = 0; index < allCookies.length; index += 1) {
    let cookie = allCookies[index];
    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1);
    }

    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length);
    }
  }

  return null;
};

export const clearAuthCookies = (): void => {
  document.cookie = `${TOKEN_COOKIE_KEY}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Lax`;
  document.cookie = `${REFRESH_TOKEN_COOKIE_KEY}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Lax`;
};
